import { Link } from 'react-router-dom';
import './SiteDesignDirectionsPage.scss';

/** Five optional directions for the mobile search overlay header (back + field + actions). */
const DIRECTIONS = [
    {
        id: 'white-strip-field',
        title: 'White strip + framed field',
        blurb:
            'Same structure as today: white bar, back control, bordered field with light fill, clear + search. Feels neutral and readable. Easiest drop-in vs your current SearchMobHeaderContent.',
        tags: ['Current baseline', 'Clear separation', 'Safe default'],
        previewClass: 'sdd-sh--1',
        preview: (
            <div className="sdd-sh__row">
                <span className="sdd-sh__back" />
                <span className="sdd-sh__field sdd-sh__field--framed" />
                <span className="sdd-sh__ico" />
                <span className="sdd-sh__ico" />
            </div>
        ),
    },
    {
        id: 'brand-ribbon',
        title: 'Brand ribbon bar',
        blurb:
            'Matches the main app header: forest green bar (#004D24), white icons, and a light pill or outlined field on top so search feels part of the same system—not a separate white sheet.',
        tags: ['Consistent with HeaderMob', 'Strong brand', 'High contrast'],
        previewClass: 'sdd-sh--2',
        preview: (
            <div className="sdd-sh__row sdd-sh__row--brand">
                <span className="sdd-sh__back sdd-sh__back--on-dark" />
                <span className="sdd-sh__field sdd-sh__field--on-brand" />
                <span className="sdd-sh__ico sdd-sh__ico--on-dark" />
                <span className="sdd-sh__ico sdd-sh__ico--on-dark" />
            </div>
        ),
    },
    {
        id: 'pill-integrated',
        title: 'Single pill container',
        blurb:
            'One continuous rounded “capsule”: back and actions sit at the ends of the same surface as the text, with a subtle divider. Reads as one control—very app-store / iOS search.',
        tags: ['Unified control', 'Modern', 'Less visual noise'],
        previewClass: 'sdd-sh--3',
        preview: (
            <div className="sdd-sh__pill">
                <span className="sdd-sh__pill-part sdd-sh__pill-part--back" />
                <span className="sdd-sh__pill-part sdd-sh__pill-part--input" />
                <span className="sdd-sh__pill-sep" />
                <span className="sdd-sh__pill-part sdd-sh__pill-part--icon" />
                <span className="sdd-sh__pill-part sdd-sh__pill-part--icon" />
            </div>
        ),
    },
    {
        id: 'underline-minimal',
        title: 'Underline minimal',
        blurb:
            'No heavy field box: flat bar, single bottom border or hairline under the text area, icons only where needed. Maximum air; best if you want search to feel lightweight and editorial.',
        tags: ['Lightweight', 'Typography-first', 'Less chrome'],
        previewClass: 'sdd-sh--4',
        preview: (
            <div className="sdd-sh__row">
                <span className="sdd-sh__back" />
                <span className="sdd-sh__underline-wrap">
                    <span className="sdd-sh__underline-text" />
                    <span className="sdd-sh__underline-rule" />
                </span>
                <span className="sdd-sh__ico" />
            </div>
        ),
    },
    {
        id: 'soft-elevated',
        title: 'Soft elevated sheet',
        blurb:
            'Page stays #f8f9fa; the bar is a white card with radius + soft shadow, field slightly inset (or same white with inner shadow). Feels tactile and “lifted”—good if the overlay should read as a panel, not a flat strip.',
        tags: ['Depth', 'Card-like', 'Friendly'],
        previewClass: 'sdd-sh--5',
        preview: (
            <div className="sdd-sh__sheet">
                <div className="sdd-sh__row sdd-sh__row--in-sheet">
                    <span className="sdd-sh__back" />
                    <span className="sdd-sh__field sdd-sh__field--inset" />
                    <span className="sdd-sh__ico" />
                    <span className="sdd-sh__ico" />
                </div>
            </div>
        ),
    },
];

export function SiteDesignDirectionsPage() {
    return (
        <div className="site-design-directions">
            <div className="site-design-directions__top">
                <Link className="site-design-directions__back" to="/">
                    ← Home
                </Link>
                <h1 className="site-design-directions__title">Search header — design directions</h1>
                <p className="site-design-directions__lead">
                    Five ways to treat the <strong>mobile search overlay header</strong> (back, query field, clear, search)—all
                    compatible with your brand and neutrals. Pick one direction before tuning spacing and type in code.
                </p>
            </div>

            <div className="site-design-directions__grid">
                {DIRECTIONS.map((d, i) => (
                    <article key={d.id} className="sdd-card">
                        <div className={`sdd-card__preview ${d.previewClass}`}>{d.preview}</div>
                        <div className="sdd-card__body">
                            <div className="sdd-card__num">Option {i + 1}</div>
                            <h2 className="sdd-card__name">{d.title}</h2>
                            <p className="sdd-card__desc">{d.blurb}</p>
                            <div className="sdd-card__tags" aria-hidden>
                                {d.tags.map((t) => (
                                    <span key={t} className="sdd-card__tag">
                                        {t}
                                    </span>
                                ))}
                            </div>
                        </div>
                    </article>
                ))}
            </div>
        </div>
    );
}
